import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_029",
  "use": "icon-su_029-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-su_029\"><defs><style>#icon-su_029 .cls-1{fill:#fff;}#icon-su_029 .cls-2{fill:#d4d4d4;}</style></defs><g id=\"icon-su_029_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_029_icon\"><rect class=\"cls-1\" x=\"0.5\" y=\"0.5\" width=\"19\" height=\"19\" /><path class=\"cls-2\" d=\"M19,1V19H1V1H19m1-1H0V20H20V0Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol